// Libraries
import Vue from 'vue'
import Vuex from 'vuex'
import persistedState from 'vuex-persistedstate'
import vuexCache from 'vuex-cache'

// Utilties
import Logger from '../utility/loggerUtil'

import { SettingsConstants } from '../constants'

import { address } from './address/module'
import { cards } from './cards/module'
import { config } from './config/module'
import { customer } from './customer/module'
import { display } from './display/module'
import { loans } from './loans/module'
import { offers } from './offers/module'
import { origination } from './origination/module'
import { payment } from './payment/module'
import { referral } from './referral/module'
import { session } from './session/module'
import { states } from './states/module'
import { store } from './store/module'
import { brands } from './brands/module'
import { appElement } from './appElement/module'

import actions from './actions'

Vue.use(Vuex)

let debounceTimer

export default new Vuex.Store({
  plugins: [
    vuexCache({ timeout: SettingsConstants.cacheTimeout }),
    persistedState({
      paths: ['customer', 'origination', 'payment'], // Only store essential modules
      storage: window.sessionStorage,
      setState (key, state, storage) {
        clearTimeout(debounceTimer)

        debounceTimer = setTimeout(() => {
          try {
            storage.setItem(key, JSON.stringify(state))
          } catch (error) {
            // TODO: Figure out if there is a way to permanently deal with QuotaExceededError
            Logger.error('Error on store state')
            Logger.debug(error)
          }
        }, 500) // Debounce to try to avoid QuotaExceededError
      }
    })
  ],
  actions,
  modules: {
    address,
    cards,
    config,
    customer,
    display,
    loans,
    offers,
    origination,
    payment,
    session,
    states,
    store,
    referral,
    brands,
    appElement
  }
})
